import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { config } from './config';

function isBlacklistedBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return ua.includes('Electron') || ua.includes('HeadlessChrome');
}

Sentry.init({
  dsn: 'https://8fe128eecbc93ca6d6d2d6a004b09d5d@o356571.ingest.us.sentry.io/4508222310580224',
  environment: config.Environment,
  release: 'messenger@0.1.0',
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.replayIntegration()
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  tracesSampleRate: 0.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  //  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event, hint) {
    if (isBlacklistedBrowser() || process.env.NODE_ENV !== 'production') return null;
    console.log(event, hint);
    return event;
  }
});
